var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{staticClass:"breadcrumb"},_vm._l((_vm.breadList),function(item,index){return _c('a-breadcrumb-item',{key:item.name},[(item.name != _vm.name && index != 1)?_c('router-link',{attrs:{"to":{ path: item.path === '' ? '/' : item.path }}},[_vm._v(_vm._s(item.meta.title))]):_c('span',[_vm._v(_vm._s(item.meta.title))])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362ae97c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Breadcrumb.vue
// module id = 33fk
// module chunks = 22